import Store from "../components/Store";
import BusinessCategory from "../components/BusinessCategory";
import BusinessSubCategory from "../components/BusinessCategory/BusinessSubCategory";
import Testing from "../components/Testing";
import VariantManagemnet from "../components/VariantMangement";
import VariantCombinations from "../components/VariantCombinations";
import Dashboard from "../components/Dashboard";
import OfferManagement from "../components/OfferManagement";
import CountryList from "../components/ManageDemoPlaces/CountryList";
import StateList from "../components/ManageDemoPlaces/StateList";
import CityList from "../components/ManageDemoPlaces/CityList";
import CustomerData from "../components/CustomerData";
import CondidateData from "../components/CandidateData";
import ProductData from "../components/ProductData";
import ProductVariantData from "../components/ProductVariantData";
import Resellers from "../components/Resellers/ListResellers";
import ResellersDashboard from "../components/Reseller/ResellersDashboard";

import ResellerProfile from "../components/Reseller/ResellerProfile";
import ResellerUpdateProfile from "../components/Reseller/ResellerUpdateProfile";
import StoreList from "../components/Reseller/StoreManagement/StoreList";
import OrdersHistory from "../components/Reseller/OrdersHistory";
import ChoosePlans from "../components/Reseller/PricingAndPlans/ChoosePlans";
import PlanDetails from "../components/Reseller/PricingAndPlans/PlanDetails";
import Groups from "../components/Groups";
import AddGroup from "../components/Groups/AddGroups";
import GroupDetail from "../components/Groups/GroupDetails";
import OrderManagement from "../components/OrderManagement";
import ProductCategory from "../components/ProductCategory";
import ProductBrand from "../components/ProductCategory/ProductBrand";
import ProductSubCategory from "../components/ProductCategory/ProductSubCategory";
import PendingApproval from "../components/PendingApproval";
import ProductVariantList from "../components/VariantMangement/ProductVariantList";
import VariantStorage from "../components/VariantStorage";
import VariantOther from "../components/VariantOther";

import ProductOther from "../components/VariantOther/ProductOther";
import ProductChoice from "../components/VariantOther/ProductOther/ProductChoice";
import ProductStorage from "../components/VariantStorage/ProductStorage";

import OrderDetail from "../components/Dashboard/OrderDetail";
import EnventryManagement from "../components/EnventryManagement";
import AvailableWallet from "../components/WalletManagement/AvailableWallet";
import WalletTransition from "../components/WalletManagement/WalletTransition";
import AddVAriantList from "../components/AddVAriantList";
import StorePendingProduct from "../components/StorePendingProduct";
import Banners from "../components/Banners";
import PendingProductApproval from "../components/PendingProductApproval";
import Enquiry from "../components/Enquiry";
import VendorSubcriptionPlan from "../components/VendorSubcriptionPlan";
import VendorSimulators from "../components/VendorSimulators";
import MyWallet from "../components/MyWallet";
import AdminMyWallet from "../components/AdminMyWallet";
import ResetPassword from "../components/ResetPassword";
import ProfileDetail from "../shared/ProfileDetail";
import RazorpayPage from "../components/RazaorpayPage";
import Firebase from "../components/Firebase";
import ReturnOrder from "../components/OrderManagement/ReturnOrder";
import ReplacementOrder from "../components/OrderManagement/ReplacementOrder";
import Slider from "../components/Slider";
import PaymentGAteway from "../components/PaymentGAteway";
import ReturnRefund from "../components/ReturnRefund";
import DeliveryManagement from "../components/DeliveryManagement";
import ShipRocket from "../components/ShipRocket";
import Porter from "../components/Porter";
import Configuration from "../components/Configuration";
import Sms from "../components/Sms";
import Whatsaap from "../components/Whatsaap";
import Subscription from "../components/Subscription";

import CustomNotification from "../components/CustomNotification";
import SubscriptionAdmin from "../components/SubscriptionAdmin";
import TestimoniolList from "../components/TestimoniolList";
import SubscriptionUserPlan from "../components/SubscriptionUserPlan";
import NewHeader from "../components/Header/NewHeader";
import MainHeader from "../components/Header/MainHeader";
import SubHeader from "../components/Header/SubHeader";
import MainSpefication from "../components/Specification/MainSpefication";
import SpecificationType from "../components/Specification/SpecificationType";
import SpecificationValue from "../components/Specification/SpecificationValue";
import InvoiceList from "../components/InvoiceList";
import CustomerList from "../components/CustomerList";
import BhaaratDelivery from "../components/BhaaratDelivery";
import StoreDataMapping from "../components/StoreDataMapping";
import DeliveryPinCode from "../components/DeliveryPinCode";
import SpecificationTypes from "../components/SpecificationTypes";
import Specifications from "../components/Specifications";
import ContactList from "../components/Contact Access";
import AdSenseForm from "../components/AddSenceApi";
import FacebooxPixelForm from "../components/FaceBookPixal";
import TermsAndCondition from "../components/Terms&Condition";
import PrivacyAndPolicy from "../components/Privacy&Policy";
import ReturnReplacement from "../components/ReturnPolicyManagement";
import { components } from "react-select";
import CodManagement from "../components/CodManagement";

export const routes = [
  {
    id: 1,
    path: "/dashboard",
    component: <Dashboard />,
  },
  {
    id: 2,
    path: "/store",
    component: <Store />,
  },
  {
    id: 2,
    path: "/store/vendor-list",
    component: <Store />,
  },
  {
    id: 2,
    path: "/store/product/pending",
    component: <StorePendingProduct />,
  },
  {
    id: 2,
    path: "/product-approval",
    component: <PendingProductApproval />,
  },
  {
    id: 4,
    path: "/business-data",
    component: <BusinessCategory />,
  },
  {
    id: 4,
    path: "/business-category",
    component: <BusinessCategory />,
  },
  {
    id: 5,
    path: "/manage-store/business-sub-type",
    component: <BusinessSubCategory />,
  },
  {
    id: 6,
    path: "/test",
    component: <Testing />,
  },

  {
    id: 7,
    path: "/manage-store",
    component: <ProductCategory />,
  },

  {
    id: 7,
    path: "/manage-demography",
    component: <CountryList />,
  },
  {
    id: 7,
    path: "/manage-demography/country",
    component: <CountryList />,
  },
  {
    id: 7,
    path: "/manage-demography/state",
    component: <StateList />,
  },
  {
    id: 7,
    path: "/manage-demography/city",
    component: <CityList />,
  },

  {
    id: 8,
    path: "/variant-mangement",
    component: <VariantManagemnet />,
  },
  {
    id: 8,
    path: "/variant-mangement-color",
    component: <VariantManagemnet />,
  },
  {
    id: 8,
    path: "/variant-mangement-storage",
    component: <VariantStorage />,
  },
  {
    id: 8,
    path: "/variant-management-other",
    component: <VariantOther />,
  },
  {
    id: 9,
    path: "/variant-combinations",
    component: <VariantCombinations />,
  },
  {
    id: 10,
    path: "/offer",
    component: <OfferManagement />,
  },
  {
    id: 11,
    path: "/customer-data",
    component: <CustomerData />,
  },
  {
    id: 12,
    path: "/candidate-data",
    component: <CondidateData />,
  },
  {
    id: 13,
    path: "/product-data",
    component: <ProductData />,
  },
  {
    id: 14,
    path: "/product-variant-data",
    component: <ProductVariantData />,
  },
  {
    id: 15,
    path: "/resellers",
    component: <Resellers />,
  },
  {
    id: 16,
    path: "/groups",
    component: <Groups />,
  },
  {
    id: 17,
    path: "/add-group",
    component: <AddGroup />,
  },
  {
    id: 18,
    path: "/group-detail/:id",
    component: <GroupDetail />,
  },
  {
    id: 19,
    path: "/order-management",
    component: <OrderManagement />,
  },
  {
    id: 19,
    path: "/order-management/customer-order",
    component: <OrderManagement />,
  },
  {
    id: 21,
    path: "/manage-product",
    component: <ProductCategory />,
  },
  {
    id: 22,
    path: "/product-brand",
    component: <ProductBrand />,
  },
  {
    id: 23,
    path: "/product-sub-category",
    component: <ProductSubCategory />,
  },
  {
    id: 24,
    path: "/pending/approval",
    component: <PendingApproval />,
  },

  {
    id: 24,
    path: "/variant-mangement-color/variant-list",
    component: <ProductVariantList />,
  },
  {
    id: 24,
    path: "/variant-mangement-storage/variant-storage-list",
    component: <ProductStorage />,
  },
  {
    id: 24,
    path: "/variant-management-other/variant-other-list",
    component: <ProductOther />,
  },
  {
    id: 25,
    path: "/variant-management-other/variant-other-list/choice",
    component: <ProductChoice />,
  },
  {
    id: 26,
    path: "/dashboard/detail",
    component: <OrderDetail />,
  },

  {
    id: 27,
    path: "/enventory-management",
    component: <EnventryManagement />,
  },
  {
    id: 27,
    path: "/enventory-management/add-product",
    component: <EnventryManagement />,
  },
  {
    id: 27,
    path: "/reset-password",
    component: <ResetPassword />,
  },

  {
    id: 27,
    path: "/custom-notofication",
    component: <CustomNotification />,
  },

  // ResetPassword
  // AvailableWallet

  {
    id: 28,
    path: "/manage-wallet",
    component: <AvailableWallet />,
  },

  {
    id: 28,
    path: "/manage-wallet/available-wallet",
    component: <AvailableWallet />,
  },
  {
    id: 28,
    path: "/manage-wallet/wallet-transition",
    component: <WalletTransition />,
  },
  {
    id: 28,
    path: "/add-product-variant",
    component: <AddVAriantList />,
  },
  {
    id: 30,
    path: "/banner",
    component: <Banners />,
  },
  {
    id: 31,
    path: "/enquiry",
    component: <Enquiry />,
  },
  {
    id: 32,
    path: "/plans",
    component: <VendorSubcriptionPlan />,
  },
  {
    id: 32,
    path: "plans/vendor-subscription-plan",
    component: <VendorSubcriptionPlan />,
  },
  {
    id: 32,
    path: "plans/vendor-point-simulators",
    component: <VendorSimulators />,
  },
  {
    id: 32,
    path: "/my-wallet",
    component: <MyWallet />,
  },
  {
    id: 32,
    path: "/wallet-diduction",
    component: <AdminMyWallet />,
  },

  {
    id: 32,
    path: "/dashboard/profile",
    component: <ProfileDetail />,
  },
  {
    id: 34,
    path: "/fire",
    component: <Firebase />,
  },
  {
    id: 35,
    path: "/return",
    component: <ReturnOrder />,
  },
  {
    id: 36,
    path: "/replace",
    component: <ReplacementOrder />,
  },
  {
    id: 37,
    path: "/slider",
    component: <Slider />,
  },
  {
    id: 38,
    path: "/payment",
    component: <PaymentGAteway />,
  },
  {
    id: 38,
    path: "/payment/available-payment",
    component: <PaymentGAteway />,
  },
  {
    id: 33,
    path: "/payment/razor",
    component: <RazorpayPage />,
  },
  {
    id: 39,
    path: "/ret",
    component: <ReturnRefund />,
  },
  {
    id: 40,
    path: "/delivery",
    component: <DeliveryManagement />,
  },
  {
    id: 41,
    path: "/delivery-management/ship-rocket",
    component: <ShipRocket />,
  },
  {
    id: 28,
    path: "/bhaarat-delivery",
    component: <BhaaratDelivery />,
  },
  {
    id: 42,
    path: "/delivery-management/porter",
    component: <Porter />,
  },
  {
    id: 43,
    path: "/configration",
    component: <Configuration />,
  },
  {
    id: 43,
    path: "/configration/email",
    component: <Configuration />,
  },
  {
    id: 44,
    path: "/sms",
    component: <Sms />,
  },
  {
    id: 46,
    path: "/whatsapp",
    component: <Whatsaap />,
  },
  {
    id: 48,
    path: "/subscription",
    component: <Subscription />,
  },
  {
    id: 48,
    path: "/variant-subscription",
    component: <SubscriptionAdmin />,
  },
  {
    id: 48,
    path: "/user-subscription",
    component: <SubscriptionUserPlan />,
  },
  {
    id: 49,
    path: "/testimonials",
    component: <TestimoniolList />,
  },

  {
    id: 49,
    path: "/addsence",
    component: <AdSenseForm />,
  },

  {
    id: 49,
    path: "/facebookpixel",
    component: <FacebooxPixelForm />,
  },

  {
    id: 52,
    path: "/product-specification",
    component: <MainSpefication />,
  },
  {
    id: 51,
    path: "/product-specification/specification",
    component: <MainSpefication />,
  },
  {
    id: 51,
    path: "/product-specification/specification-type",
    component: <SpecificationType />,
  },
  {
    id: 51,
    path: "/product-specification/specification-value",
    component: <SpecificationValue />,
  },

  {
    id: 52,
    path: "/customization",
    component: <NewHeader />,
  },
  {
    id: 52,
    path: "/customization/header",
    component: <NewHeader />,
  },
  {
    id: 52,
    path: "/customization/main-header",
    component: <MainHeader />,
  },
  {
    id: 52,
    path: "/customization/sub-header",
    component: <SubHeader />,
  },

  {
    id: 53,
    path: "/invoice",
    component: <InvoiceList />,
  },
  {
    id: 54,
    path: "/customer-list",
    component: <CustomerList />,
  },

  {
    id: 54,
    path: "/store-data-mapping",
    component: <StoreDataMapping />,
  },

  // delivery pincode start page
  {
    id: 54,
    path: "/delivery-pincode",
    component: <DeliveryPinCode />,
  },
  // delivery pincode end page
  {
    id: 55,
    path: "/specification-types",
    component: <SpecificationTypes />,
  },
  {
    id: 56,
    path: "/specification-type/:id",
    component: <Specifications />,
  },

  {
    id: 57,
    path: "/contact-access",
    component: <ContactList />,
  },

  {
    id: 58,
    path: "/terms&condition",
    component: <TermsAndCondition />,
  },

  {
    id: 59,
    path: "/privacy&policy",
    component: <PrivacyAndPolicy />,
  },

  {
    id: 60,
    path: "/return&replacement",
    component: <ReturnReplacement />,
  },
  {
    id: 8,
    path: "/cod-management",
    component: <CodManagement />
  }
];
// DeliveryPinCode

export const resellersRoutes = [
  {
    id: 1,
    path: "/resellers/dashboard",
    component: <ResellersDashboard />,
  },
  {
    id: 2,
    path: "/resellers/store-management",
    component: <StoreList />,
  },
  {
    id: 3,
    path: "/resellers/profile",
    component: <ResellerProfile />,
  },
  {
    id: 4,
    path: "/resellers/update-profile",
    component: <ResellerUpdateProfile />,
  },
  {
    id: 5,
    path: "/resellers/pricing-and-plans",
    component: <ChoosePlans />,
  },
  {
    id: 6,
    path: "/resellers/orders-history",
    component: <OrdersHistory />,
  },
  {
    id: 7,
    path: "/resellers/pricing-and-plans/details",
    component: <PlanDetails />,
  },


];
